import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import CardSection from '@shared/components/CardSection';
import type { LicenseInfo } from '../types';

interface Props {
  licenses: LicenseInfo[];
}

const licenseColorMap: Record<LicenseInfo['status'], 'success' | 'warning' | 'error'> = {
  valid: 'success',
  expiring: 'warning',
  expired: 'error',
};

function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export default function LicenseStatus({ licenses }: Props) {
  return (
    <CardSection>
      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
        Licenses
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {licenses.map((lic) => (
          <Box
            key={lic.productType}
            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
          >
            <Box>
              <Typography variant="body2">{lic.productType}</Typography>
              <Typography variant="caption" color="text.secondary">
                Expires: {formatDate(lic.validUntil)}
              </Typography>
            </Box>
            <Chip label={lic.status} color={licenseColorMap[lic.status]} size="small" />
          </Box>
        ))}
      </Box>
    </CardSection>
  );
}
